var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'dark': _vm.darkMode}},[_c('igt-notifications'),_c('div',{staticClass:"flex flex-col h-screen"},[_c('sj-header'),_c('sj-action-generator',{staticClass:"flex-grow"}),_c('sj-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }